// HOOKS
import { createContext } from "react";
import useGetManyROIs from "../../hooks/rois/useGetMany.roi";

export const ROIsContext = createContext({
  rois: [],
  setROIs: () => {},
  getROIs: () => {},
  metaData: {},
  setMetaData: () => {},
  roiInput: {},
  setROIInput: () => {},
  query: {},
  setQuery: () => {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
  isLoading: false,
  error: null,
  handleChange: () => {},
});

export const ROIsProvider = ({ children }) => {
  const {
    rois,
    setROIs,
    getROIs,
    metaData,
    setMetaData,
    roiInput,
    setROIInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading: isLoading,
    error,
  } = useGetManyROIs();

  const handleChange = async (event) => {
    try {
      const { name, value, dataset } = event.target;
      const { id } = dataset;

      // Update ROI in state
      setROIs(
        rois?.map((roi) => (roi._id === id ? { ...roi, [name]: value } : roi))
      );
    } catch (error) {
      console.error(`Error updating ROI: ${error.message}`);
      alert(`Error updating ROI: ${error.message}`);
    }
  };

  return (
    <ROIsContext.Provider
      value={{
        rois,
        setROIs,
        getROIs,
        metaData,
        setMetaData,
        roiInput,
        setROIInput,
        query,
        setQuery,
        handleLimitChange,
        handlePageChange,
        handleSearch,
        handleSort,
        isLoading,
        error,
        handleChange,
      }}
    >
      {children}
    </ROIsContext.Provider>
  );
};
